// 表单填写公共函数
const formMixin = {
  data() {
    return {
      form: this.$form.createForm(this),
      //（分销）资料详情、设置的相关页面使用
      baseItemLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 4 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 22 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 20 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 3 },
          lg: { span: 4 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 20 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      // 主要用于提交按钮
      formItemLayoutBtn: {
        wrapperCol: {
          xxl: { offset: 2 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 4 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },// 主要用于提交按钮
      formItemLayoutBtn2: {
        wrapperCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 4 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      uploadFileUrl: this.getUploadFileUrl(),//图片上传地址
      saveLoading: false,
      submitLoading: false
    }
  },

  methods: {
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    updateForm(obj) {
      this.$nextTick(() => {
        this.form.setFieldsValue(obj)
      })
    },

    resetForm(formName) {
      if (formName) {
        this.$refs[formName].resetFields()
      } else {
        this.form.resetFields()
      }
    },
    getSubmitFormParams(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            resolve(valid)
          } else {
            reject(valid)
          }
        })
      })
    },


    /**
     * 校验获取表单数据
     */
    validateFormParams(fields) {
      return new Promise((resolve, reject) => {
        if (fields && fields instanceof Array) {
          this.form.validateFieldsAndScroll([...fields], { force: true }, (err, values) => {
            if (!err) {
              resolve(values)
            } else {
              reject(values)
            }
          })
        } else {
          this.form.validateFieldsAndScroll((err, values) => {
            this.getLogUtils().logWithTag('==values==', values)
            if (!err) {
              resolve(values)
            } else {
              reject(values)
            }
          })
        }

      })
    },
    /**
     * 图片类型校验
     * @param file
     * @returns {boolean}
     */
    handleBeforeUploadImage(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isGIF = file.type === 'image/gif'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isGIF || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
      }
      return true
    },
    //Excel文件校验
    handleBeforeUploadExcelFile(file) {
      let extensionsName = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = extensionsName === 'xls'
      const extension2 = extensionsName === 'xlsx'
      if (!extension && !extension2) {
        this.$message.error('上传文件只能是 xls、xlsx格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
        return false
      }
      return true
    },
    /**
     * 图片类型校验 剔除GIF图
     * @param file
     * @returns {boolean}
     */
    handleBeforeUploadDocxFile(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于1M!')
        return false
      }
      return true
    },
    /**
     *文本校验
     * @param file          上传的文件
     * @param verifyList    需要校验的格式集合  必须数组
     * @param fileSize      上传文件大小
     * @param isShowMessage 是否需要提示
     */
    handleCommonBeforeUpload(file, verifyList, fileSize = 0, isShowMessage = true) {
      let regular = new RegExp('[ +]')
      let extensionsName = file.name.substring(file.name.lastIndexOf('.') + 1)//截取文件后缀
      let extension = verifyList.indexOf(extensionsName)//能否找到上传文件的后缀 找到是对应下标,找不到是-1
      if (extension === -1) {
        if (isShowMessage) {
          this.$message.error('上传文件只能是' + verifyList.join('、') + '格式!')
        }
        return false
      }
      if (fileSize) {//是否需要校验上传文件大小  默认是0不需要校验文件大小
        const isLt2M = file.size / 1024 / 1024 < Number(fileSize)
        if (!isLt2M) {
          this.$message.error('上传的文件不能大于' + fileSize + 'M!')
          return false
        }
      }
      return true
    },


    /**
     *文本校验
     * @param rule
     * @param value
     * @param callback
     * @param number
     */
    handleText(rule, value, callback, number) {
      if (value && value.length > number) {
        callback(new Error('不能超过' + number + '个字'))
      } else {
        callback()
      }
    },
    /**
     * 手机号码校验规则
     * @param rule
     * @param value
     * @param callback
     */
    handlePhoneInput(rule, value, callback) {
      if (value) {
        if (this.isPhone(value)) {
          callback()
        } else {
          callback(new Error('手机号码格式有误'))
        }
      } else {
        callback(new Error('手机号不能为空'))
      }
    },
    isPhone(value) {
      if (value) {
        return /^1[3456789]\d{9}$/.test(value)
      }
      return false
    },
    isTelPhone(value) {
      if (value) {
        return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(value)
      }
      return false
    },
    isEmail(value) {
      if (value) {
        const regex = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
        return regex.test(value)
      }
      return false
    },
    /**
     * 座机电话校验
     * @param rule
     * @param value
     * @param callback
     */
    handleTelephoneInput(rule, value, callback) {
      if (!value) {
        if (this.isTelPhone(value)) {
          callback()
        } else {
          callback(new Error('电话号码格式有误'))
        }
      } else {
        callback(new Error('电话号码不能为空'))
      }
    },
    handleUsernameOrEmail(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入手机号或邮箱地址'))
      } else if (this.isPhone(value) || this.isEmail(value)) {
        callback()
      } else {
        callback(new Error('账号格式有误'))
      }
    },
    handleEmailInput(rule, value, callback) {
      if (this.isEmail(value)) {
        callback()
      } else {
        callback(new Error('邮箱格式有误'))
      }
    },
    getFileList(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map(file => {
        if (file.response) {
          file.data = file.response.data
        }
        return file
      })
      return fileList
    },

    getUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        if (fileList[0] && fileList[0].response) {
          return fileList[0].response.data
        }
      }
      return ''
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    getUrlFromFileListArr(fileList) {
      if (fileList && fileList.length > 0) {
        if (fileList[0] && fileList[0].response) {
          return [fileList[0].response.data]
        } else if (fileList[0] && fileList[0].url) {
          return [fileList[0].url]
        }
      }
      return []
    }

  }
}
export default formMixin
